import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

import "./WindowShade.scss";

const click = (className, toggleVisible) => ({ target }) => {
	const {
		className: targetClassName,
	} = target;

	if (new RegExp(className).test(targetClassName)) {
		toggleVisible();
	}
};

const WindowShade = ({ isVisible, toggleVisible, children }) => {
	const className = "payment-window-shade";

	return (
		<div
			role="presentation"
			className={classnames({
				[className]: true,
				"payment-window-shade--show": isVisible,
			})}
			onClick={click(className, toggleVisible)}
		>
			{children}
		</div>
	);
};

WindowShade.propTypes = {
	isVisible: PropTypes.bool.isRequired,
	toggleVisible: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired,
};

export default WindowShade;



// WEBPACK FOOTER //
// ./src/shared/payment/components/WindowShade/index.jsx